var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSafeArea),expression:"showSafeArea"}],staticClass:"safe-area-top",style:(`height:${_vm.height}px`)})
}
var staticRenderFns = []

export { render, staticRenderFns }